import React, { useReducer, useContext, useEffect, createContext } from 'react';
import FullCard from '../../../../components/Card/FullCard';
import Divider from '@material-ui/core/Divider';
import UsersActionsButtons from './UsersActionsButtons';
import { __ } from '../../../../utils/i18n';
import UsersSearchBox from './UsersSearchBox';
import UsersList from './UsersList';
import { initialState, reducer, actions } from './reducer';
import { makeStyles } from '@material-ui/core/styles';
import axios from '../../../../api/axios';
import { store as mainStore } from '../../../../store';
import { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import useRules from "../../../../hooks/useRules"

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  operatorBody: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': { marginBottom: 10, width: '500px' },
  },
}));

export const store = createContext(null);
const { Provider } = store;

const Users = ({ config: { name: title } }) => {
  const classes = useStyles();
  const history = useHistory();
  const [rules,hasRule,isAdmin] = useRules();
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
    showMessage,
    showError,
  } = useContext(mainStore);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { search, page } = state;

  const handleRefresh = async () => {
    try {
      const res = await actions.fetchingUsers(page, 10, search);
      dispatch({ type: 'USERS', payload: res });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Provider value={{ state, dispatch, actions, refresh: handleRefresh }}>
      <FullCard
        title={title}
        actions={hasRule('can_manage_operators') ? <UsersActionsButtons /> : null}
      >
        <div className={classes.root}>
          {hasRule('can_manage_operators') ? (
            <Fragment>
              <UsersSearchBox />
              <Divider />
              <UsersList />
            </Fragment>
          ) : (
            <Fragment>
              <div className={classes.operatorBody}>
                <div>لطفا انتخاب کنید:</div>
                <Button
                  variant="contained"
                  size="large"
                  color="secondary"
                  onClick={() =>
                    history.push('/protected/admin/users/customers')
                  }
                >
                  مدیریت مشتریان
                </Button>
                <Button
                  onClick={() => history.push('/protected/admin/users/drivers')}
                  variant="contained"
                  size="large"
                  color="secondary"
                >
                  مدیریت رانندگان
                </Button>
              </div>
            </Fragment>
          )}
        </div>
      </FullCard>
    </Provider>
  );
};

export default React.memo(Users);
